<template>
  <div v-if="checkPermission(['country', 'PUT'])">
    <span class="text-center table-edit-icon" @click="showModal">
      <i class="text-center material-icons">edit</i>
    </span>
    <div class="centerx">
      <vs-popup
        :id="'popmodal' + params.data.country_id"
        class="holamundo editModal"
        title="Update Country"
        :active.sync="popupActive"
      >
        <form>
          <FocusLock>
            <div class="vx-row">
              <!-- LEFT SIDE -->
              <div class="col-12">
                <div class="vx-row mb-6">
                  <div class="col-4 text-right align-self-center">
                    <h5 class="mb-0">Country Name</h5>
                  </div>
                  <div class="col-7">
                    <!-- Start ************* -->
                    <div>
                      <!-- label="country_name" -->
                      <multiselect
                        v-model="country_value"
                        track-by="country_id"
                        label="text"
                        placeholder="Select Country"
                        :options="cityOptions"
                        name="Country Name"
                        :searchable="true"
                        :allow-empty="false"
                        open-direction="bottom"
                        deselect-label="Can't remove this value"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">{{
                          option.text
                        }}</template>
                        <!-- {{ option.country_name }} -->
                      </multiselect>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('Country Name')"
                        >{{ errors.first("Country Name") }}</span
                      >
                    </div>
                    <!-- End ************* -->
                  </div>
                </div>

                <div class="vx-row mb-6">
                  <div class="col-4 text-right align-self-center">
                    <h5 class="mb-0">Country Code</h5>
                  </div>
                  <div class="col-7">
                    <div class>
                      <vs-input
                        v-validate="'required'"
                        name="Country name"
                        v-model="form.country_code"
                        class="w-full"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('Country name')"
                        >{{ errors.first("Country name") }}</span
                      >
                    </div>
                  </div>
                </div>

                <div class="vx-row mb-6">
                  <div class="col-4 text-right align-self-center">
                    <h5 class="mb-0">Country Timezone</h5>
                  </div>
                  <div class="col-7">
                    <!-- Start ************* -->
                    <div>
                      <!-- label="country_name" -->
                      <multiselect
                        v-model="country_value"
                        track-by="country_id"
                        label="text"
                        placeholder="Select Country"
                        :options="cityOptions"
                        name="Country Name"
                        :searchable="true"
                        :allow-empty="false"
                        open-direction="bottom"
                        deselect-label="Can't remove this value"
                      >
                        <template slot="singleLabel" slot-scope="{ option }">{{
                          option.text
                        }}</template>
                        <!-- {{ option.country_name }} -->
                      </multiselect>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('Country Name')"
                        >{{ errors.first("Country Name") }}</span
                      >
                    </div>
                    <!-- End ************* -->
                  </div>
                </div>
              </div>
            </div>

            <!-- SUBMIT BUTTON -->
            <div class="vx-row">
              <div class="vx-col mx-auto">
                <!-- :disabled="submitStatus" -->
                <vs-button
                  :disabled="submitStatus"
                  type="filled"
                  @click.prevent="submitForm"
                  class="mr-3"
                  >Update</vs-button
                >

                <!-- <vs-button color="warning" type="border" class @click.prevent="clearForm">Reset</vs-button> -->
              </div>
            </div>
          </FocusLock>
        </form>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// import CurrencyService from "@/services/countryService";
import CountryService from "@/services/countryService.js";

export default Vue.extend({
  data() {
    return {
      switch1: true,
      submitStatus: true,
      country_value: [],
      form: {
        country_name: "",
        country_code: "",
      },
      companies: [],
      cityOptions: [
        { text: "New York", value: "new-york" },
        { text: "Chicago", value: "chicago" },
        { text: "San Francisco", value: "san-francisco" },
        { text: "Boston", value: "boston" },
      ],
      popupActive: false,
      params: null,
      value: null,
      count: 0,
    };
  },
  watch: {
    form: {
      handler: function (newVal, oldVal) {
        if (this.count > 0) {
          this.submitStatus = false;
        }
        this.count++;
      },
      deep: true,
    },
  },
  beforeMount() {
    this.value = this.params.value;
    this.form = this.params.data;
    // this.getCompanyList();
  },
  beforeDestroy() {
    let _id = document.getElementById("popmodal" + this.params.data.country_id);
    _id.setAttribute("style", "display: none;");
  },
  methods: {
    showModal() {
      // console.log(this.params.data.department_active, "fsdfsd");

      // console.log("afsadf");
      this.popupActive = true;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.$vs.loading();
        if (result) {
          this.submitStatus = true;
          let id = this.form.country_id;
          let payload = {
            country_name: this.form.country_name,
            country_id: this.form.country_id,
            country_code: this.form.country_code,
            country_active: this.params.country_active,
          };
          CountryService.editCountry(payload, id)
            .then((response) => {
              this.$vs.loading.close();
              this.submitStatus = false;
              const { data } = response;
              this.popupActive = false;
              if (data.Status == true || data.Status == "true") {
                this.$vs.notify({
                  title: "Updated!",
                  text: data.Message,
                  iconPack: "feather",
                  icon: "check_box",
                  color: "success",
                });
                setTimeout(() => {
                  eventBus.$emit("refreshTable", data);
                }, 1);
                this.clearForm();
              } else {
                this.$vs.loading.close();
                console.log("data :", data);
                this.$vs.notify({
                  title: "Error!",
                  text: data.Message,
                  iconPack: "feather",
                  icon: "check_box",
                  color: "warning",
                });
              }
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.submitStatus = true;
              console.log("error :", error);
            });
          // if form have no errors
          // alert("form submitted!");
        } else {
          // form have errors
        }
      });
    },

    clearForm: function () {
      Object.keys(this.form).map((x, index) => {
        /_active/.test(x) ? (this.form[x] = "1") : (this.form[x] = "");
      });
      this.$validator.reset();
    },
  },

  mounted() {},
});
</script>
<style>
</style>